import { asText } from '@prismicio/helpers';
import { ClientLogosSlider } from 'remote-com-shared/components/ClientLogos/ClientLogosSlider';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import Illustration from './assets/pattern.png';

import { transformProperties } from '@/src/domains/prismic/helpers';
import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const IllustrationWrapper = styled.div`
  background-image: url(${Illustration.src});
  ${fluidProp('height', '100px', '234px')}

  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

export function LogosSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { context } = slice;

  const { title } = primary;
  const { clientLogosView } = context;
  return (
    <>
      <ClientLogosSlider bossa customTitle={asText(title)} {...clientLogosView} />
      <IllustrationWrapper />
    </>
  );
}
